import styled from 'styled-components';

export const TrendLegend = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const TrendLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TrendLegendDot = styled.div<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${({ $color }) => $color};
`;
